module.exports = __webpack_public_path__ + "img/sasha.c3cadf91.png";